<template>
  <div ref="body" class="section">
    <div>
      <dl>
        <dt>
          <div class="container publicity">
            <div class="th item col-md-1">序号</div>
            <div class="th item col-md-1">姓名</div>
            <div class="th item col-md-1">学校</div>
            <div class="th item col-md-1">年级</div>
            <div class="th item col-md-1">作品名</div>
          </div>
        </dt>
        <dd v-for="(row, idx) in top">
          <div class="container publicity" :id="idx" :ref="idx">
            <div class="item col-md-1">{{row[0]}}</div>
            <div class="item col-md-1">{{row[1]}}</div>
            <div class="item col-md-1">{{row[2]}}</div>
            <div class="item col-md-1">{{row[3]}}</div>
            <div class="item col-md-3">{{row[4]}}</div>
          </div>
        </dd><br/><br/><br/><br/><br/>
      </dl>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import { Loading } from 'element-ui'

  export default {
    components: {
    },
    data () {
      return {
        url: this.API,
        groups: ['大一','大二','大三'],
        top: [
        ],
      }
    },
    mounted () {
    },
    computed: {
    },
    methods: {
      _getData: function () {
        let _t = this
        let ld = Loading.service({'fullscreen': true, 'text': '数据加载中，请稍后'})
        axios.post(_t.API + '/api/work/toplist')
          .then(function (resp) {
            if (resp.data.code == '0') {
              _t.top = resp.data.data
            } else {
              _t.$messagewarning(resp.data.msg)
              console.log(resp.data)
            }
            ld.close()
          })
          .catch(function (error) {
            console.log(error)
            ld.close()
          })
      }
    }
  }
</script>

<style scoped>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 60px;
    width: 100%;
    align-items: center;
  }

  .item {
    flex: 3;
    word-wrap: break-word;
    text-align: center;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid aliceblue;
  }

  html, body, #imageList {
    height: 100%;
    width: 100%;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .titleImage{
    width: 100%;
    height: auto;
  }

  .imgList {
    margin: 0 auto;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
  }

  .imgBox {
    width: 100%;
    height: 100%;
    margin-bottom: 50px;
    border: 1px solid;
    position: relative;
  }

  .imgBox img{
    width: 100%;
    height: auto;
  }

  .imgMask {
    position: absolute;
    /*margin-top: 800px;*/
    height: 40%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 100;
    background: rgba(0, 0, 0, .6);
  }

  .imgPosition {
    bottom: -40%;
  }

  .showImg {
    height: auto;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 10px solid #fff;
  }

  .bigImg {
    width: 100%;
    height: 100%;
  }

  .prev {
    position: absolute;
    top: 50%;
    left: 10px;
    width: 100px;
    transform: translate(10px, -50%);
    z-index: 80;
  }

  .next {
    width: 100px;
    transform: translate(10px, -50%);
    position: absolute;
    top: 50%;
    right: 20px;
    z-index: 80;
  }

  a:link {color:#a3a3a3;}		/* 未被访问的链接 */
  a:visited {color:#FF00FF;}	/* 已被访问的链接 */
  a:hover {color:#9cbeec;}	/* 鼠标指针移动到链接上 */
  a:active {color:#9cbeec;}
  .section{
      padding: 30px calc((100% - 1024px) / 2) 0;
  }
  .th {
    font-size: 18px;
    color: #fff;
    background: #25335e;
  }
  .col-md-1 {
  }
  .col-md-3 {
    color: rgba(0,0,0,0.6);
  }
</style>



// WEBPACK FOOTER //
// Top100.vue?7c663fdc